import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { BasketService } from '@df/session/api/basket/basket.service';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { ICmsModalService } from '@icms/client/assets/modal/icms-modal.service';
import { TradeStoreService } from '../multisite/trade/trade-store.service';
import { BasketAddPromoGiftService } from './add-promo-gift/basket-add-promo-gift.service';
@Injectable({
    providedIn: 'root'
})
export class MinibasketInitiatorLocalService extends AbstractDfModalInitiatorService {
    constructor(
        cmsModalService: ICmsModalService,
        app: App,
        private basketService: BasketService,
        private tradeStoreService: TradeStoreService,
        private basketAddPromoGiftService: BasketAddPromoGiftService
    ) {
        super(cmsModalService, app);
    }
    listen(cb: () => void): Promise<void> {
        return new Promise(resolve => {
            this.basketService.subscribeToAddToBasketSuccess(eventData => {
                if (eventData.response?.amastyPromoGiftProducts && this.app.client.sizeId > 1) {
                    this.basketAddPromoGiftService.getPromoProduct(eventData.response?.amastyPromoGiftProducts);
                }
                if (!eventData.response?.preventMinibasketOpen && !this.tradeStoreService.isTradeStore()) {
                    cb();
                }
            });
            resolve();
        });
    }
}
